import React, { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { useSearchParams } from 'react-router-dom'
import { Box } from '@mui/material'

import { BI_ROUTES } from '@constants'
import { isLoadingCommonFilters, resetCommonFilters } from '@signals'
import { AppStartHint, searchStartHintProps } from '@components'
import { BIChartData, BIHeaders, BISelectedOffice, BISelectedOfficeOptions, BITableData, clearBISignals, setFormData } from './@signals'
import PageWrapper from 'Pages/@PageWrapper'
import BIFilters from './Filters'
import BIPageContent from './Content'
import BIPageWrapperActions from 'Pages/BusinessLogistics/BI/Page/Actions'
import VirtualTourButton, { TourOverlay, TOUR_STEPS } from './VirtualTour'
import BIDemoData from './VirtualTour/DemoData'


export default function BIPage() {
	const [tourActive, setTourActive] = useState(false)
	// The hint is for a page nobody has searched yet; after an empty search the views say so themselves.
	const hasSearched = useRef(false)
	if (isLoadingCommonFilters.value) hasSearched.current = true
	const hasResults = !!BITableData.value.rowValues?.length || !!BIChartData.value.chartData || !!BIHeaders.value?.length
	const [searchParams] = useSearchParams()

	useEffect(() => {
		resetCommonFilters()
		clearBISignals()
		BISelectedOfficeOptions.value = []
		BISelectedOffice.value = null

		const sp = searchParams.get('sp')
		if (sp) {
			try {
				const bytes = new Uint8Array([...atob(sp)].map(c => c.charCodeAt(0)))
				const decoded = JSON.parse(new TextDecoder().decode(bytes))
				setFormData({ ...decoded, urlId: searchParams.get('urlId') })
			} catch {}
		}

		return () => {
			resetCommonFilters()
			clearBISignals()
			BISelectedOfficeOptions.value = []
			BISelectedOffice.value = null
		}
	}, [])

	return <PageWrapper
		head={`DS Rentacar | ${BI_ROUTES.TITLE}`}
		title={BI_ROUTES.TITLE}
		subtitle={BI_ROUTES.SUBTITLE}
		isEmpty={false}
		filters={<BIFilters/>}
		actions={<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
			<BIPageWrapperActions/>
			<VirtualTourButton onClick={() => setTourActive(true)} />
		</Box>}
	>
		{!hasSearched.current && !hasResults && !tourActive && <AppStartHint {...searchStartHintProps}/>}
		<BIPageContent/>
		{tourActive && <BIDemoData />}
		{tourActive && createPortal(
			<TourOverlay steps={TOUR_STEPS} onClose={() => setTourActive(false)} />,
			document.body
		)}
	</PageWrapper>
}
